import React from 'react';

import { observer } from 'mobx-react-lite';

import { freeBetStore, useTranslation } from '@pascal/pascal-core';

import { doBetStore } from '../../store/doBetStore';
import { reBetStore } from '../../store/reBetStore';

const { handleReBetClick } = doBetStore;

const ReBet = observer(() => {
  const t = useTranslation();

  // const handleDisabled = () =>
  //   doBetStore.pigs.some(
  //     (pig) => !pig.freeBetId || pig.betId || pig.betAmount || (!freeBetStore.activeFreeBet.id && pig.freeBetId)
  //   ) || !reBetStore.reBetInfo.length
  //     ? 'disable'
  //     : '';
  const handleDisabled = () => {
    let string = '';
    // eslint-disable-next-line consistent-return,array-callback-return
    doBetStore.pigs.forEach((pigs) => {
      if (doBetStore.pigs.some((pig) => pig.freeBetId) && !freeBetStore.activeFreeBet.id) {
        // eslint-disable-next-line no-return-assign
        return (string = 'disable');
      }
      if (pigs.freeBetId && freeBetStore.activeFreeBet.id) {
        return string;
      }
      if (
        doBetStore.pigs.every(
          (pig) => pig.betId || pig.betAmount || (!pig.freeBetId && freeBetStore.activeFreeBet.id)
        ) ||
        !reBetStore.reBetInfo.length
      ) {
        // eslint-disable-next-line no-return-assign
        return (string = 'disable');
      }
    });

    if (
      doBetStore.pigs.some(
        (pig) => pig.betId || pig.betAmount || (!freeBetStore.activeFreeBet.id && pig.freeBetId)
      ) ||
      !reBetStore.reBetInfo.length
    ) {
      // eslint-disable-next-line no-return-assign
      return (string = 'disable');
    }

    return string;
  };
  return (
    <div className={`c-m-rebet-btn-wrapper ${handleDisabled()}`} title={t('REBET')}>
      <div className='c-m-rebet-btn-holder'>
        <button type='button' onClick={handleReBetClick} className='c-m-rebet-btn'>
          <i className='icon-rebet-1' />
        </button>
      </div>
      <span className='c-m-rebet-btn-txt'>{t('REPEAT')}</span>
    </div>
  );
});

export default ReBet;
